import { put, select, takeLatest } from 'redux-saga/effects'
import { getPnMedicationSelector } from '../selectors/pnMedication.selector'
import { setAddMedicationAdministeredData } from '../store/pnMedication.actions'
import { PnMedicationConstants } from '../store/pnMedication.constants'
import { IPnMedicationState } from '../store/pnMedication.types'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { cloneDeep } from 'lodash'

export function* setMedication() {
  const pnMedicationState: IPnMedicationState = yield select(getPnMedicationSelector)
  try {
    const { medication, pnMedication, addMedicationAdministeredData } = pnMedicationState
    const selectedMedicationIndex = addMedicationAdministeredData?.findIndex(
      (medication) => medication.id === pnMedication?.id
    )
    if (selectedMedicationIndex > -1) {
      const addMedicationAdministeredDataClone = cloneDeep(addMedicationAdministeredData)
      addMedicationAdministeredDataClone[selectedMedicationIndex].medication = medication
      yield put(setAddMedicationAdministeredData(addMedicationAdministeredDataClone))
    }
  } catch (e) {
    yield put(throwPcrException(`PN Medication setMedication() error: ${e}`))
  }
}

export function* setMedicationSaga() {
  yield takeLatest([PnMedicationConstants.SET_MEDICATION], performWithMutexHOG, setMedication)
}
